import { render, staticRenderFns } from "./GiftCertificatesBanner.vue?vue&type=template&id=7d8f6117&scoped=true&"
import script from "./GiftCertificatesBanner.vue?vue&type=script&setup=true&lang=ts&"
export * from "./GiftCertificatesBanner.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./GiftCertificatesBanner.vue?vue&type=style&index=0&id=7d8f6117&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d8f6117",
  null
  
)

export default component.exports